export default __webpack_public_path__ + "static/media/5l.7a3fce3d.svg";